import AuthError from 'src/features/auth/components/AuthError';

export default function AuthErrorPage() {
  return <AuthError redirectUrl="/plugins/outlook/login" />;
}
